<template>
  <div v-if="hasSchedule" class="schedule-list">
    <section class="info-section">
      <div class="info-grid">
        <span>預計領取團數</span>
        <span v-if="isScheduleFinish">—</span>
        <span v-else>共 {{ schedules.length }} 團</span>
        <span>團購公告時間</span>
        <span>{{ orderCreateTime }}</span>
        <span>開放訂購時間</span>
        <span>起始日{{ orderStartTime }}-訖日{{ orderEndTime }}</span>
      </div>
    </section>
    <section>
      <div class="detail-card">
        <b-table
          :data="tableData"
          class="max-h-[300px]"
          scrollable
          sticky-header
        >
          <template #empty>
            <div class="empty-message">
              <template v-if="isScheduleFinish">
                <p>沒有即將開始的例行性團購</p>
                <p>或</p>
                <p>例行性團購已完結</p>
              </template>
              <template v-else>
                尚未設定例行性設定
              </template>
            </div>
          </template>
          <b-table-column
            field="index"
            label="No."
            width="22px"
            v-slot="props">
            <span class="text-sm">
              {{ `${props.row.index ? `${props.row.index}.` : ''}` }}
            </span>
          </b-table-column>
          <b-table-column
            field="createDate"
            label="公告日期"
            width="110px"
            v-slot="props">
              <span class="text-sm">
                {{ props.row.createDate }}
              </span>
          </b-table-column>
          <b-table-column
            field="startDate"
            label="開放訂購日期"
            width="100px"
            v-slot="props">
            <span class="text-sm">
              {{ props.row.startDate }}
            </span>
          </b-table-column>
          <b-table-column
            field="receiveDate"
            label="領取時間"
            v-slot="props">
            <span class="text-sm">
              {{ props.row.receiveDateStart }}
            </span>
            <span class="text-gray-500 text-sm">
              {{ props.row.receiveTimeStart }}
              -
            </span>
            <span class="text-sm">
              {{ props.row.receiveDateEnd }}
            </span>
            <span class="text-gray-500 text-sm">
              {{ props.row.receiveTimeEnd }}
            </span>
          </b-table-column>
        </b-table>
      </div>
    </section>
  </div>
</template>

<script>
import ScheduleList from './ScheduleList';

export default ScheduleList;
</script>

<style lang="scss" scoped>
@import './ScheduleList.scss';
</style>
